// Runtime configuration — identical pattern on admin and provider portals.
// Deployed: window.__RUNTIME_CONFIG__ from start.sh (ECS task env + Secrets Manager).
// Local CRA: process.env from .env files.

interface RuntimeConfig {
  REACT_APP_API_URL: string;
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_GOOGLE_MAPS_JS_API_KEY?: string;
}

const getRuntimeConfig = (): RuntimeConfig => {
  const fromWindow =
    typeof window !== 'undefined'
      ? ((window as any).__RUNTIME_CONFIG__ as Partial<RuntimeConfig> | undefined)
      : undefined;

  return {
    REACT_APP_API_URL:
      fromWindow?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000',
    REACT_APP_ENVIRONMENT:
      fromWindow?.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT || 'local',
    REACT_APP_GOOGLE_MAPS_JS_API_KEY:
      fromWindow?.REACT_APP_GOOGLE_MAPS_JS_API_KEY ||
      process.env.REACT_APP_GOOGLE_MAPS_JS_API_KEY ||
      '',
  };
};

/** Fresh read each call — avoids stale module-init if config script loads late. */
export function getRuntimeConfigValue(): RuntimeConfig {
  return getRuntimeConfig();
}

export const runtimeConfig = getRuntimeConfig();

console.log('Runtime Configuration:', {
  ...runtimeConfig,
  REACT_APP_GOOGLE_MAPS_JS_API_KEY: runtimeConfig.REACT_APP_GOOGLE_MAPS_JS_API_KEY ? '(set)' : '(empty)',
});
